export function formatPinWithSpacing(pin?: string): string | undefined {
  if (!pin || pin.length <= 5) {
    return pin;
  }

  const pinLength = pin.length;

  if (pinLength === 7) {
    return `${pin.slice(0, 3)} ${pin.slice(3)}`;
  } else if (pinLength === 10) {
    return `${pin.slice(0, 3)} ${pin.slice(3, 6)} ${pin.slice(6)}`;
  } else if (pinLength === 13) {
    return `${pin.slice(0, 3)} ${pin.slice(3, 6)} ${pin.slice(6, 9)} ${pin.slice(9)}`;
  }

  return pin.match(/.{1,3}/g)?.join(' ') || pin;
}
